"use strict";

exports.__esModule = true;
exports.Popover = Popover;

var React = _interopRequireWildcard(require("react"));

var _context = require("./context");

var _reactPopover = require("@radix-ui/react-popover");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/popover/src/Popover.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Popover(props) {
  const {
    align = 'center',
    children,
    isOpen,
    offset = [0, 8],
    placement = 'bottom',
    onChange,
    onEscapeKeyDown,
    onOutsideClick
  } = props;
  return React.createElement(_reactPopover.Popover, {
    open: isOpen,
    onOpenChange: onChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 5
    }
  }, React.createElement(_context.PopoverContext.Provider, {
    value: {
      align,
      offset,
      onEscapeKeyDown,
      onOutsideClick,
      placement
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 7
    }
  }, children));
}

Popover.displayName = 'Popover';